import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { NGX_MONACO_EDITOR_CONFIG, NgxMonacoEditorConfig } from './config/config';
import { MonacoDiffEditorComponent } from './components/monaco-diff-editor/monaco-diff-editor.component';
import { MonacoEditorComponent } from './components/monaco-editor/monaco-editor.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    MonacoEditorComponent,
    MonacoDiffEditorComponent
  ],
  exports: [
    MonacoEditorComponent,
    MonacoDiffEditorComponent
  ],
  entryComponents: [
    MonacoEditorComponent,
    MonacoDiffEditorComponent
  ]
})
export class NgMonacoEditorModule {
  public static forRoot(config: NgxMonacoEditorConfig = {}): ModuleWithProviders {
    return {
      ngModule: NgMonacoEditorModule,
      providers: [
        { provide: NGX_MONACO_EDITOR_CONFIG, useValue: config }
      ]
    };
  }
}
